import { render, staticRenderFns } from "./AskEmail.vue?vue&type=template&id=32a93aa6&scoped=true&"
import script from "./AskEmail.vue?vue&type=script&lang=js&"
export * from "./AskEmail.vue?vue&type=script&lang=js&"
import style0 from "./AskEmail.vue?vue&type=style&index=0&id=32a93aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a93aa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VFlex,VForm,VLayout,VSpacer,VSwitch,VTextField})
